import { createMuiTheme } from '@material-ui/core'

const theme = createMuiTheme({
  palette: {
    primary: {
      main: 'rgba(254, 220, 86, 1)',
      contrastText: 'black',
    },
    secondary: {
      main: 'rgba(255, 179, 0, 1)',
      contrastText: 'white',
    },
    background: {
      main: '#E5E5E5',
    },
  },
})

theme.typography.body = {
  ...theme.typography.body,
  fontSize: '1.5rem',
  lineHeight: '2.375rem',
}

theme.typography.h1 = {
  ...theme.typography.h1,
  fontSize: '2rem',
  fontWeight: 900,
  lineHeight: '2.375rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '2.625rem',
  },
}

theme.typography.h2 = {
  ...theme.typography.h2,
  fontSize: '1.5rem',
  lineHeight: '2.375rem',
  fontWeight: 700,
  [theme.breakpoints.up('sm')]: {
    fontSize: '1.75rem',
  },
}

theme.typography.h3 = {
  ...theme.typography.h3,
  fontSize: '1.75rem',
  fontWeight: 700,
  lineHeight: '2.375rem',
}

theme.typography.button = {
  ...theme.typography.button,
  fontSize: '1.25rem',
  textTransform: 'normal',
}

theme.typography.subtitle1 = {
  ...theme.typography.subtitle1,
  fontSize: '1.25rem',
  lineHeight: '2.375rem',
  [theme.breakpoints.up('sm')]: {
    fontSize: '2.1875rem',
  },
}

export default theme
